import Vue from 'vue'
import App from './App.vue'
import store from './store'
import VueForm from 'vue-form'

Vue.config.productionTip = false
Vue.use(VueForm, {
  inputClasses: {
    valid: 'form-control-success',
    invalid: 'form-control-danger'
  }
});

//require('../node_modules/bootstrap/dist/css/bootstrap.css')

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
